import { getFileById, getFileStream } from '@/service/api/basic'

/** 使手机号部分数字隐藏 */
export function changePhoneNum(phone: string | undefined) {
  if (!phone)
    return
  const processPhone = `${phone.substr(0, 3)}****${phone.substr(7)}`
  return processPhone
}
/** 去掉后台返回时间的毫秒 */
export function formatTime(timeStr: string) {
  return timeStr?.replace(/\.\d+$/, '')
}
/** 只需要时间的年月日 */
export function formatDate(timeStr: string | undefined) {
  if (!timeStr)
    return ''
  return timeStr?.split(' ')[0]
}
/** 只需要时间的年月日 */
export function formatDate2(timeStr: any) {
  const date = new Date(timeStr)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0') // 确保两位数，补零
  const day = String(date.getDate()).padStart(2, '0')// 确保两位数，补零

  return `${year}-${month}-${day}`
}
/** IDC产品根据优先级获取值 */
export function serverFields(oneStr: any, twoStr: any, threeStr: any) {
  return oneStr || twoStr || threeStr || '--'
}

/* 处理状态：N表示未处理，C表示处理中，Y表示已处理 */
export function getQueshandle(queshandle: string) {
  let val = '未处理'
  switch (queshandle) {
    case 'N':
      val = '未处理'
      break
    case 'C':
      val = '处理中'
      break
    case 'Y':
      val = '已处理'
      break
    default:
      val = '未处理'
      break
  }
  return val
}

/* 处理状态颜色：N表示未处理#C8C9CC，C表示处理中#1989FA，Y表示已处理#07C160 */
export function getQueshandleColor(queshandle: string) {
  let color = '#C8C9CC'
  switch (queshandle) {
    case 'N':
      color = '#C8C9CC'
      break
    case 'C':
      color = '#1989FA'
      break
    case 'Y':
      color = '#07C160'
      break
    default:
      color = '#C8C9CC'
      break
  }
  return color
}

/**
 * 信息title绑定
 *
 * @memberof
 */
export function setTitle(data: any, value: string) {
  const result = data.filter((res: any) => value === res.value)
  const res = result.length !== 0 ? result[0].text : ''
  return res
}

/** 根据value返回对应的attribute */
export function setValue(data: any, value: any, attribute: string) {
  const result = data.filter((res: any) => value === res.value)
  const res = result.length !== 0 ? result[0][attribute] : ''
  return res
}

/**
 * data: 数据
 * value: 需要对比的值
 * params: 需要对比的参数
 * attribute：输出的属性的值
 */
export function setCommonValue(data: any, value: any, params: string, attribute: string) {
  const result = data.filter((res: any) => value === res[params])
  const res = result.length !== 0 ? result[0][attribute] : ''
  return res
}

/**
 * 颜色绑定
 *
 * @memberof
 */
export function setColor(data: any, value: string) {
  const result = data.filter((res: any) => value === res.value)
  const res = result.length !== 0 ? result[0].color : ''
  return res
}
/**
处理金额格式
 */
export function formatAmount(amount: string | number) {
  // 转为字符串
  amount = amount.toString()

  // 检查是否有小数点
  let hasDecimal = false
  if (amount?.indexOf('.') !== -1) {
    hasDecimal = true
  }

  // 拆分整数部分和小数部分
  const parts: any = amount.split('.')
  const integerPart = parts[0]
  let decimalPart = ''
  if (hasDecimal) {
    decimalPart = `.${parts[1]}`
  }

  // 格式化整数部分
  let formattedIntegerPart = ''
  for (let i = integerPart.length - 1, count = 0; i >= 0; i--, count++) {
    if (count !== 0 && count % 3 === 0) {
      formattedIntegerPart = `,${formattedIntegerPart}`
    }
    formattedIntegerPart = integerPart[i] + formattedIntegerPart
  }

  // 返回格式化的金额
  return formattedIntegerPart + decimalPart
}

/**
 * 金额格式化：货币符号 + 千分位 + 两位小数；无效值返回 '--'
 */
export function formatCurrency(value?: number | string | null) {
  if (value == null || value === '' || Number.isNaN(Number(value)))
    return '--'
  return `¥${formatAmount(Number(value).toFixed(2))}`
}

/**
 *  ISO 8601 格式的时间字符串转换回本地时间的 Date 对象,差8个时区
 */
export function parseISOStringToDate(iso8601DateString: Date) {
  const originalDate = new Date(iso8601DateString)
  // 获取本地时区偏移（分钟）
  const timezoneOffset = originalDate.getTimezoneOffset()
  // 调整时间以考虑时区偏移
  const adjustedDate = new Date(
    originalDate.getTime() - timezoneOffset * 60000,
  )

  return adjustedDate
}

/**
 * 判断是否包含bdate或edate，并返回其下标
 */
export function findDateIndex(valObj: any, targetParam: string) {
  if (!valObj || !Array.isArray(valObj)) {
    return -1 // 判断valObj.dateQueryList是否存在且为数组
  }
  const index = valObj.findIndex((x: any) => {
    return x.queryField === targetParam
  })
  return index !== -1 ? index : -1 // 如果找不到，返回0
}

/**
 * 文件下载
 */
export async function downloadFile(i: any) {
  i.loading = true

  const fileList: any = await getFileStream(i.id)
  i.loading = false
  const blob = new Blob([fileList], { type: 'application/pdf' })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  document.body.appendChild(a)
  a.href = url
  a.download = i.fileNewName
  a.click()
  URL.revokeObjectURL(url)
}

/**
 * 取文件扩展名（兼容 fileNewName / fileName 缺失的情况）
 */
function getFileExt(i: any): string {
  return (i?.fileNewName || i?.fileName || '').split('.').pop()?.toLowerCase() || ''
}

const imageExts = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp']
// 压缩包 / 安装包等无法在线预览的二进制格式，只提供下载
const nonPreviewableExts = ['rar', 'zip', '7z', 'gz', 'tar', 'tgz', 'exe', 'dmg', 'apk', 'iso', 'msi', 'bin']

/**
 * 是否支持在线预览（图片 / 桌面端 PDF）
 */
export function isPreviewable(i: any): boolean {
  const ext = getFileExt(i)
  return imageExts.includes(ext) || (ext === 'pdf' && window.innerWidth > 768)
}

/**
 * 是否为不可在线预览的格式（压缩包 / 安装包等）
 */
export function isNonPreviewable(i: any): boolean {
  return nonPreviewableExts.includes(getFileExt(i))
}

/**
 * 文件预览
 */
export async function showFile(i: any) {
  // 压缩包等无法在线预览的格式，直接下载，不打开第三方预览插件
  if (isNonPreviewable(i)) {
    await downloadFile(i)
    return
  }
  const originUrl = `/file-management/file/getFileStream?id=${i.id}`
  const previewUrl = `${originUrl}&fullfilename=${i.fileNewName}`
  const ext = getFileExt(i)
  const isImage = imageExts.includes(ext)
  // 图片走本地预览（不依赖第三方服务）；PDF 仅桌面端走本地，移动端仍用插件
  const isLocalPreview = isPreviewable(i)
  i.loading = true

  if (isLocalPreview) {
    const fileList: any = await getFileStream(i.id)
    i.loading = false
    const mime = isImage ? `image/${ext === 'jpg' ? 'jpeg' : ext}` : 'application/pdf'
    const blob = new Blob([fileList], { type: mime })
    const url = window.URL.createObjectURL(blob)
    const newWindow = window.open('', '_blank')

    if (newWindow) {
      // 图片：用 <img> 直接渲染，兼容移动端/桌面端
      if (isImage) {
        newWindow.document.write(`
          <html>
            <head>
              <title>${i.fileNewName}</title>
              <style>
                html, body { margin: 0; padding: 0; min-height: 100%; background: #f5f5f5; }
                .wrap { padding: 10px 20px; }
                a {
                  text-decoration: unset;
                  height: 36px;
                  line-height: 36px;
                  border-radius: 4px;
                  font-size: 16px;
                  background: #0c59db;
                  color: #fff;
                  padding: 0 26px;
                  cursor: pointer;
                  display: inline-block;
                  box-shadow: 0 0px 10px 1px rgba(12, 89, 219, 0.4);
                }
                img { display: block; max-width: 100%; margin: 12px auto; }
              </style>
            </head>
            <body>
              <div class="wrap"><a href="${url}" download="${i.fileNewName}">下载${i.fileNewName}</a></div>
              <img src="${url}" alt="${i.fileNewName}" />
            </body>
          </html>
        `)
      }
      // PDF：用 <iframe> 渲染
      else {
        newWindow.document.write(`
          <html>
            <head>
              <title>${i.fileNewName}</title>
              <style>
                html, body {
                  margin: 0;
                  padding: 0;
                  height: 100%;
                  overflow: hidden;
                }
                iframe {
                  width: 100%;
                  height:calc(100% - 130px);
                  border: none;
                }
                 a{
                     text-decoration: unset;
                  height: 40px;
                  line-height: 40px;
                  border-radius: 4px;
                  font-size: 16px;
                  background: #0c59db;
                  color: #fff;
                  padding: 0 26px;
                  cursor: pointer;
                  height: 36px;
                  display: inline-block;
                  box-shadow: 0 0px 10px 1px rgba(12, 89, 219, 0.4);
                  }
                  .wrap{padding:10px 20px}
              </style>
            </head>
            <body>
            <div class="wrap">
              <p><a href="${url}" download="${i.fileNewName}">下载${i.fileNewName}</a></p>
              </div>
              <iframe src="${url}"></iframe>
            </body>
          </html>
        `)
      }
      newWindow.document.close()
    }
  }
  // 其余格式用插件打开
  else {
    i.loading = false
    const utf8Bytes = new TextEncoder().encode(`https://service.1198.cn${previewUrl}`)
    let binary = ''
    utf8Bytes.forEach((byte) => {
      binary += String.fromCharCode(byte)
    })
    window.open(`https://fileview.seaarea.com/onlinePreview?url=${(btoa(binary))}`)
  }
}

/**
 * 按文件id调起文件预览（自动获取文件名，非图片文件使用）
 */
export async function previewFileById(id: any) {
  if (id == null)
    return
  const { data } = await getFileById(id)
  const fileNewName = data?.fileNewName || `file_${id}`
  await showFile({ id, fileNewName })
}

/**
 * idc产品续费按钮点击
 */
export function idcRenewalBtn(id: any, type: string) {
  sessionStorage.setItem('idcBatchRenewal', JSON.stringify([id]))
  sessionStorage.setItem('renewalType', type)
}
